import { EVENT_TYPE_NAMES } from '../../common/analytics/amplitudeEventTypesUtil';
import { slugify } from '../../common/utils/stringUtil';
import { TIMES, getTimestamp } from '../../common/utils/timeUtil';
import { sendAmplitudeEvent } from '../analytics/amplitudeServiceJS';
import { NewRelicPageActions, sendNewRelicPageAction } from '../analytics/newRelicUtils';
import localStorageService from '../utils/services/localStorage/localStorage';
import { getLastRefreshTimeLocalStorage } from './appLocalCacheStorageService';

export const hasMultipleAppRefreshesOccurred = (timeSince: number): boolean => {
    const lastRefreshTime = getLastRefreshTimeLocalStorage();
    const currentTimeStamp = getTimestamp();
    const hasMultipleAppRefreshesOccurred = lastRefreshTime && Number(lastRefreshTime) + timeSince > currentTimeStamp;

    return !!hasMultipleAppRefreshesOccurred;
};

// FIXME-INSTANT-APP Remove amplitude and only use new relic after new relic is enabled in prod
// This function is used to send the amplitude and new relic event for multiple refreshes
// it will send the event only if the last event was sent more than 4 hours ago
// it does that by storing the last event timestamp in local storage and checking it before sending the event
// the local storage key name follows the same structure used in amplitudeAnalyticsMiddleware
export const throttleAndSendAnalyticsEventLastPersistedTime = (timeSince = 10 * TIMES.HOUR): void => {
    const amplitudeEventLocalStorageKeyName = `milanote.amplitude_limit.${slugify(
        EVENT_TYPE_NAMES.APP_MULTI_REFRESH,
        '_',
    )}`;
    const currentTimeStamp = getTimestamp();
    const lastAnalyticsEventTimestamp = Number(localStorageService.getItem(amplitudeEventLocalStorageKeyName));

    if (lastAnalyticsEventTimestamp && lastAnalyticsEventTimestamp + timeSince > currentTimeStamp) return;

    localStorageService.setItem(amplitudeEventLocalStorageKeyName, currentTimeStamp.toString());

    sendAmplitudeEvent({
        eventType: EVENT_TYPE_NAMES.APP_MULTI_REFRESH,
    });

    sendNewRelicPageAction(NewRelicPageActions.APP_MULTI_REFRESH);
};
